import React, { useCallback, useState } from "react";
import MvmSlider from "./MvmSlider";
import MissionCard from "./MissionCard";
const MissionSlider = ({ missions }) => {
    const [showError, setShowError] = useState(false);
    const renderMissions = useCallback(() => {
        return missions.map((mission) => (React.createElement("div", { key: mission.id, className: "py-3" },
            React.createElement(MissionCard, { mission: mission, setShowError: setShowError }))));
    }, [missions]);
    return (React.createElement("div", null,
        React.createElement(MvmSlider, null, renderMissions()),
        showError &&
            React.createElement("div", { className: "specialty-challenge-message hidden text-center mb-2" },
                React.createElement("span", { className: "text-danger" }, "Specialty challenge cannot be accessed via the MVM website. Please use The Conqueror Challenge app."))));
};
export default MissionSlider;
